import React, { useState } from "react";
import classNames from "classnames";
import ImageEmotionalWellbeing from "../../images/img-emotional-well-being.png";
import ImageExercise from "../../images/img-exercise.png";
import ImageHealthyLifestyle from "../../images/img-maintain-healthy-lifestyle.png";
import ImagePracticeRelaxation from "../../images/img-practice-relaxation.png";
import contentData from "./data";

import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import TrendsGraph from "../TrendsGraph";
import processGraphData from "../TrendsGraph/progressGraphData";

import _ from "lodash";
import { useAuth0 } from "@auth0/auth0-react";

const getBetterText = (diffValue, title) => {
  if (title == "Fatigue" || title == "Illness") {
    return diffValue > 0 ? "Better" : "Deteriorated";
  }
  return diffValue < 0 ? "Better" : "Deteriorated";
};

function AccordianItem({
  id,
  title,
  results,
  accordianClass,
  showAccordianItem,
  setActiveItem,
  isAccordianOpen,
  imageSrc,
  outOfText,
  diffValue,
  rgbaColor,
  score,
  isFirstResult,
  createFreeAccount,
}) {
  const [slide, setSlide] = useState();
  const { isAuthenticated } = useAuth0();
  const toggleSlide = (data) => {
    setSlide((k) => {
      if (k && _.isEqual(data, k)) {
        setActiveItem(null);
        return null;
      } else {
        setActiveItem(title);
        return data;
      }
    });
  };

  return (
    <div
      className={classNames("accordian-elem", {
        "show-acc ": showAccordianItem,
        "show-accordian": isAccordianOpen,
        " show-tabs-bottom": isAccordianOpen && !slide?.tab,
        "show-tabs-top": slide?.tab,
        "triangle-left": slide?.name != "show-slide-3",
        "triangle-right": slide?.name == "show-slide-3",
      })}
    >
      <div className={classNames("inner_emotii_list", accordianClass)}>
        <span className="cursor-pointer heading-text">
          <h3
            className=""
            onClick={() => toggleSlide({ name: "show-slide-1" })}
          >
            {title}
          </h3>
        </span>
        <span className="block_emotii_title cursor-pointer">
          {imageSrc && (
            <img
              src={imageSrc}
              style={{ width: "60px", height: "60px", objectFit: "contain" }}
              alt=""
              className="h-fit"
            />
          )}
          <div
            onClick={() => toggleSlide({ name: "show-slide-3" })}
            className="inner_statastic"
          >
            <span className="w-full text-sm">
              <span className="text-4xl font-bold">{score}</span>
              {outOfText}
            </span>
            <span
              className={classNames("text-xs", { invisible: isFirstResult })}
            >
              <strong className="text-base">
                <i>
                  {diffValue == 0
                    ? "No"
                    : diffValue > 0
                    ? `+${diffValue}`
                    : diffValue}{" "}
                </i>
              </strong>
              <span> change</span>
            </span>
          </div>
        </span>
        <div
          className={classNames("trianlge", {
            invisible: slide?.name === "show-slide-2",
          })}
        ></div>
      </div>

      <div className={classNames("inner_tabs", accordianClass)}>
        <ul className="inner_tabs_list" id="tab_list">
          <li className="inner_tab">
            <a
              href="#tips"
              data-tab="tips"
              className={classNames("b-nav-tab inner_tab_text", {
                "active-tab": slide?.tab == "tips",
              })}
              onClick={() => toggleSlide({ name: "show-slide-2", tab: "tips" })}
            >
              Tips
            </a>
          </li>
          <li className="inner_tab">
            <a
              href="#tools"
              data-tab="tools"
              className={classNames("b-nav-tab inner_tab_text", {
                "active-tab": slide?.tab == "tools",
              })}
              onClick={() =>
                toggleSlide({ name: "show-slide-2", tab: "tools" })
              }
            >
              Tools
            </a>
          </li>
          <li className="inner_tab border-r-0">
            <a
              href="#trends"
              data-tab="trends"
              className={classNames("b-nav-tab inner_tab_text", {
                "active-tab": slide?.tab == "trends",
              })}
              onClick={() =>
                toggleSlide({ name: "show-slide-2", tab: "trends" })
              }
            >
              Trends
            </a>
          </li>
        </ul>
      </div>

      <div className={classNames("detail-box", slide?.name)}>
        <div className="block-result-content-silde1 slide-1">
          <div className="general-info" id="general-info">
            {contentData[id]?.descriptors?.map((k) => (
              <>
                <p>{k}</p>
                <br />
              </>
            ))}

            {/* <div className="inner-block">
              <div className="innr_img_box">
                <img src={ImagePhysicalHealth} alt="" className="m-auto w-16" />
                <span
                  className={classNames("inner-border-img", accordianClass)}
                ></span>
              </div>
              <div className="inner-right-info">
                <h3 className="text-red-500">Physical Health</h3>
                <p>
                  Chronic stress can have a detrimental impact on your physical
                  health. It may lead to a weakened immune system, making you
                  more susceptible to illnesses and infections. Stress can also
                  contribute to the development or exacerbation of various
                  health conditions, including cardiovascular diseases,
                  digestive disorders, and respiratory problems.
                </p>
              </div>
            </div>

            <div className="inner-block bg-green-50">
              <div className="innr_img_box">
                <img src={ImageMentalHealth} alt="" className="m-auto w-16" />
                <span className="inner-border-img bg-anxiety "></span>
              </div>
              <div className="inner-right-info">
                <h3 className="text-green-500">Mental Health</h3>
                <p>
                  Prolonged stress can significantly affect your mental
                  well-being. It may contribute to the development or worsening
                  of conditions such as anxiety disorders and depression. Stress
                  can also impair cognitive function, affecting your memory,
                  concentration, and decision-making abilities.
                </p>
              </div>
            </div>

            <div className="inner-block bg-indigo-50">
              <div className="innr_img_box">
                <img
                  src={ImageEmotionalWellbeing}
                  alt=""
                  className="m-auto w-16"
                />
                <span className="inner-border-img bg-indigo-500"></span>
              </div>
              <div className="inner-right-info">
                <h3 className="text-indigo-500">Emotional Well-being</h3>
                <p>
                  Stress can lead to emotional instability and negatively impact
                  your overall mood. It may result in irritability, anger,
                  frustration, and more.
                </p>
              </div>
            </div> */}
          </div>
        </div>

        <div className="block-result-content-silde2 slide-2">
          <div className="inner-content-scroll">
            <div
              id="tips"
              className={classNames("hidden", {
                "active-tab": slide?.tab == "tips",
              })}
            >
              <p className="inner_tab_content_text">
                {/* There are several effective strategies you can employ to manage
                and reduce stress. Here are some common and recommended methods: */}
              </p>

              <div className="inner-block">
                <div className="innr_img_box">
                  <img src={ImageExercise} alt="" className="m-auto w-16" />
                  <span
                    className={classNames("inner-border-img", accordianClass)}
                  ></span>
                </div>
                <div className="inner-right-info">
                  <h3 className="text-red-500">
                    {" "}
                    {contentData[id]?.tips[0]?.title}
                  </h3>
                  <p>{contentData[id]?.tips[0]?.subtitle}</p>
                </div>
              </div>

              <div className="inner-block bg-green-50">
                <div className="innr_img_box">
                  <img
                    src={ImagePracticeRelaxation}
                    alt=""
                    className="m-auto w-16"
                  />
                  <span className="inner-border-img  bg-anxiety"></span>
                </div>
                <div className="inner-right-info">
                  <h3 className="text-green-500">
                    {contentData[id]?.tips[1]?.title}
                  </h3>
                  <p>{contentData[id]?.tips[1]?.subtitle}</p>
                </div>
              </div>

              <div className="inner-block bg-indigo-50">
                <div className="innr_img_box">
                  <img
                    src={ImageHealthyLifestyle}
                    alt=""
                    className="m-auto w-16"
                  />
                  <span className="inner-border-img bg-indigo-500"></span>
                </div>
                <div className="inner-right-info">
                  <h3 className="text-indigo-500">
                    {contentData[id]?.tips[2]?.title}
                  </h3>
                  <p>{contentData[id]?.tips[2]?.subtitle}</p>
                </div>
              </div>
            </div>

            <div
              id="tools"
              className={classNames("hidden", {
                "active-tab": slide?.tab == "tools",
              })}
            >
              <p className="inner_tab_content_text">
                Here are some tools and resources you can utilize to improve
                your emotional and mental health:
              </p>
            </div>

            <div
              id="trends"
              className={classNames("hidden", {
                "active-tab": slide?.tab == "trends",
              })}
            >
              {isAuthenticated && (
                <div
                  style={{ height: "300px", width: "100%", padding: "10px" }}
                >
                  <TrendsGraph
                    title={title}
                    payloadData={processGraphData(results, title)}
                    backgroundColor={rgbaColor}
                    borderColor={rgbaColor.replace(0.2, 1)}
                    borderWidth={2}
                  />
                </div>
              )}
              <p className="inner_tab_content_text">
                {/* Since Jan 21, your stress score has gone up. */}
                {/* <br />
                <br /> */}
                {/* Since May 9, your stress score has gotten 20% better. */}
                <br />
                <br />
                {isAuthenticated ? (
                  <>
                    Check <strong>Tips</strong> and <strong>Tools</strong> to
                    learn more ways to reduce your stress and feel even better!
                  </>
                ) : (
                  <>
                    Tracking your Emotii results over time is only possible if
                    you have a free account. To set one up now,{" "}
                    <a
                      href="#"
                      className="text-blue-700"
                      onClick={createFreeAccount}
                    >
                      click here
                    </a>
                    .
                  </>
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="block-result-content-silde1 slide-3">
          <div className="general-info" id="score-info">
            <div className="flex justify-center align-center ">
              <div className="w-1/4">
                <CircularProgressbarWithChildren
                  value={score}
                  strokeWidth={10}
                  pathStrokeWidth={20}
                  backgroundPadding={20}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    pathSize: "70%",
                    strokeWidth: "50px",
                    pathColor: rgbaColor.replace(0.2, 1),
                    trailColor: rgbaColor,
                  })}
                >
                  <span
                    className={`text-${title?.toLowerCase()} text-2xl md:text-4xl font-bold`}
                  >
                    {score}
                  </span>
                  {outOfText}
                </CircularProgressbarWithChildren>
              </div>
            </div>
            {diffValue ? (
              <h3
                className={`text-${title?.toLowerCase()} px-4 mt-2 font-bold`}
              >
                {Math.abs(diffValue)}% {getBetterText(diffValue, title)}
              </h3>
            ) : (
              ""
            )}
            <p className="p-4">
              {/* On a scale of 0 - 100, where 0 represents the least amount of
              stress and 100 represents the most extreme stress, you scored a
              44. */}
              <br />
              <br />
              When looking at your Emotii scores, it is helpful to compare them
              to look for relationships between emotion categories. Stress and
              anxiety, for example, are often related to each other.
              <br />
              <br />
              If this is the first time you’ve taken Emotii For Health, then
              it’d be helpful to think of this score as a baseline. We encourage
              you to use Emotii for Health every couple of weeks to monitor the
              changes in your stress levels over time. Your goal, of course, is
              to get this score as low as possible.
              <br />
              <br />
              Take a look at the various Tips & Tools provided to learn how to
              reduce your stress further.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccordianItem;
